// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js","682":"component---src-pages-about-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"532":"bdc4475b4a576addc8aa","678":"4aa52ac2f751cf9d9a12","682":"b06b4e0d24749fb24c86","883":"57e1a640943ce4cd19e0"}[chunkId] + ".js";
};